<script setup lang="ts">
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  interface SkeletonProps {
    class?: HTMLAttributes['class'];
    noAnimation?: boolean;
  }

  const props = defineProps<SkeletonProps>();
</script>

<template>
  <div :class="cn('rounded bg-accent', noAnimation ? '' : 'animate-pulse', props.class)" />
</template>
